import { defineStore } from 'pinia';

/**
 *
 *
 *
 * @type {StoreDefinition<"adminOptions", {adminOptions: [{value: {where: [string], text: string, title: string, type: string, status: boolean}, key: string},{value: {where: [string], text: string, title: string, type: string, status: boolean}, key: string},{value: {where: [string], text: string, title: string, type: string, status: boolean}, key: string},{value: {where: [], text: string, title: string, type: string, status: boolean}, key: string},{value: {where: [string], text: string, title: string, type: string, status: boolean}, key: string}], isEnabled: boolean, tlsFilter: number}, {}, {isItemNotLoaded(*): boolean}>}
 */
export const useAdminOptionsStore = defineStore('adminOptions', {
    state: function () {

        return {

            /**
             *
             * All items here will have a default status set of false.
             * The true and false state value is yes and no respectively. This is intended behaviour, generally we use boolean but here we want to have three states, i.e. not loaded yet, loaded and true, loaded and false.
             *
             * The keys needs to be same as command
             *
             */
            adminOptions: [
                {
                    value: {
                        status: false,
                        title: 'Safesearch',
                        text: 'Force Google and some other search engines in Safesearch mode',
                        where: ['categoriesOptions',],
                        type: 'on_off',
                    },
                    key: 'safesearch',
                },
                {
                    value: {
                        status: false,
                        title: 'Youtube Restrict',
                        text: 'Set Youtube in Youtube-restrict mode',
                        where: ['categoriesOptions',],
                        type: 'on_off',
                    },
                    key: 'youtube-restrict',
                },
                {
                    value: {
                        status: false,
                        title: 'Unbound forward',
                        text: 'You can toggle unbound forward value from here',
                        where: ['adminMenu',],
                        type: 'on_off',
                    },
                    'key': 'unbound-forward',
                },
                {
                    value: {
                        status: false,
                        title: 'SOS',
                        text: 'You can toggle SOS value from here',
                        where: [],
                        type: 'on_off',
                    },
                    key: 'SOS',
                },
                {
                    value: {
                        status: false,
                        title: 'TLS filter',
                        text: 'You can toggle TLS filter from here',
                        where: ['adminMenu',],
                        type: 'on_off',
                    },
                    key: 'tlsfilter',
                },

            ],
            tlsFilter: -1,
            isEnabled: false,
        };

    },
    actions: {

        isItemNotLoaded(item) {

            let index = this.adminOptions.findIndex((option) => {
                if (option.key === item) {
                    return option.value.status === false;
                }
            });

            return (index >= 0);

        },

    },

});
